import EvalComplete from '@/shared/publish/Homework/EvalComplete';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/publish/Homework/EvalComplete')({
  component: RouteComponent,
})

function RouteComponent() {
  return <EvalComplete />
}
